// extracted by mini-css-extract-plugin
export default {"no_post":"Posts_no_post__q17kB","loading":"Posts_loading__kDcs-","posts":"Posts_posts__Smyyj","info":"Posts_info__00sn4","loadButton":"Posts_loadButton__7wDKk"};